<div class="magic-link-container">
  <div class="magic-link-form">
    <div class="magic-link-form-title">MAGIC LINK</div>

    @if(isSent) {
      <div class="magic-link-success">
        <div class="magic-link-success-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="#35732F"/>
          </svg>
        </div>
        <div class="magic-link-success-title">Check your email</div>
        <div class="magic-link-success-text">
          We've sent a magic link to your email address. Click the link in the email to log in.
        </div>
        <div class="magic-link-success-note">
          The link will expire in 5 minutes.
        </div>
        <button
          class="magic-link-form-button dark-button"
          [routerLink]="['/login']"
        >BACK TO LOGIN</button>
      </div>
    } @else {
      <div class="magic-link-form-description">
        Enter your email address and we'll send you a link to log in without a password.
      </div>
      <form [formGroup]="form" class="magic-link-form-container">
        <label for="email-input" class="magic-link-form-container-label">Email</label>
        <input
          id="email-input"
          [ngClass]="{'magic-link-form-container-input__error': form.get('email')?.invalid && form.get('email')?.touched}"
          class="magic-link-form-container-input"
          type="text"
          formControlName="email">

        @if(form.get('email')?.invalid && form.get('email')?.touched) {
          <span class="magic-link-form-container-error">Please enter a valid email</span>
        }

        <div class="magic-link-form-button-container">
          <button
            class="magic-link-form-button red-button"
            [ngClass]="{'disabled': form.invalid || loading}"
            [disabled]="form.invalid || loading"
            (click)="sendMagicLink()"
          >
            @if(loading) {
              Loading...
            } @else {
              SEND MAGIC LINK
            }
          </button>

          <button
            class="magic-link-form-button dark-button"
            [routerLink]="['/login']"
          >BACK TO LOGIN</button>
        </div>
      </form>
    }
  </div>
</div>
